import './main.css'
import { openOrderOnWebsite } from "../Funtions/openOrderOnWebsite";

// import sample from '../assets/samples/s1.png'
import { useEffect, useRef, useState } from 'react';

import body from '../assets/body.png'
import def_shirt from '../assets/SHIRT.png'

/**
 * Whether the server confirmed this order's payment with Razorpay.
 *
 * Orders written by /api/place-order carry serverVerified and amountCaptured,
 * which the Firestore rules do not let a browser write. Anything without them
 * was written by the browser and its price and "paid" flag are only the
 * customer's word - check the payment id in the Razorpay dashboard first.
 */
const inr = (n) => Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 0, style: 'currency', currency: 'INR' });

function PaymentCheck({ order }) {
    const check = order.priceCheck || {};
    if (order.serverVerified && check.status === 'shortfall') {
        return (
            <div className="order-pay-check order-pay-check--bad" title={`Payment ${order.payment_id || ''}`}>
                ⚠ Paid {inr(order.amountCaptured)} — expected about {inr(check.reference)}. Check before making it.
            </div>
        );
    }
    if (order.serverVerified) {
        return (
            <div className="order-pay-check order-pay-check--good" title={`Payment ${order.payment_id || ''}`}>
                ✓ Razorpay confirmed {inr(order.amountCaptured)}
            </div>
        );
    }
    return (
        <div className="order-pay-check order-pay-check--warn" title="Written by the customer's browser, not confirmed by the server">
            Not server-checked — confirm {order.payment_id || 'the payment'} in Razorpay
        </div>
    );
}

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

/* Keep in sync with order_page.js orderStatus indices */
const orderStatus = ["Pending Confirmation", "Order Confirmed", "Order Processing", "In Transit", "Order Delivered"];

function Order_card({order, setOrder, setModal, setUpdate, setOrderModal}) {

    const [status, setStatus] = useState(
        order["status"] ? order["status"].status : 0
    )
    useEffect(()=>{
        setStatus(
            order["status"] ? order["status"].status : 0
        )
    }, [order])
    const notesRef = useRef()

    const [statusDate, setStatusDate] = useState()

    const [date, setDate] = useState([(new Date(order.Date)).getFullYear(), 
        (new Date(order.Date)).getMonth(),
        (new Date(order.Date)).getDate()])
    
        const [load, setLoad] = useState(true)
    const counter = useRef(0);

    useEffect(() => {
        if (order.status && order.status.Date) {
            const d = new Date(order.status.Date);
            if (!Number.isNaN(d.getTime())) {
                setStatusDate([d.getFullYear(), d.getMonth(), d.getDate()]);
            }
        }
    }, [order]);

    const imageLoaded1 = () => {
        counter.current += 1;
        let L
        if(!order.types){
            L=1;
        }else{
            L = order.types.length;
        }
         
        
        
        if (counter.current >= L) {
            setLoad(false);
            counter.current = 0;
        }
    }

    return ( 
        <div className="order_card">
            <div className="o-c-t">
                <div className='order-id-mob'>
                <div className="o-c-t-c ">
                    <div>ORDER PLACED</div>
                    <div>{date[2]}, {months[date[1]]} {date[0]}</div>
                </div>
                </div>
                <div className="o-c-t-c total-mob">
                    <div>TOTAL</div>
                    <div>
                    { Object.keys(order).includes("item_type") && order.item_type === 0 ? 
                    <>
                        {Number(250).toLocaleString('en-IN', {
                            maximumFractionDigits: 2,
                            style: 'currency',
                            currency: 'INR'
                            })}</>
                        :
                    
                        <>{Number(order.price).toLocaleString('en-IN', {
                        maximumFractionDigits: 2,
                        style: 'currency',
                        currency: 'INR'
                        })}</>
                        }
                    </div>
                </div>
                <div className="o-c-t-c1">
                    <label>ORDER # </label>
                    <label>{order.id}</label>
                </div>
                <PaymentCheck order={order} />

                <div className={`order-card-status order-card-status--s${status}`}>
                    {status === 0
                        ? "Pending confirmation"
                        : status === orderStatus.length - 1
                          ? "Delivered"
                          : "In progress"}
                </div>
            </div>
            <div className="o-c-d">
                <div className='order-img'>
                    {/* {load && (<div className='f-loading'
                    >
                        <img alt src="https://d1fufvy4xao6k9.cloudfront.net/images/garment/loading.svg" onerror="this.src='https://d1fufvy4xao6k9.cloudfront.net/images/garment/loading.gif'"/>
                    </div>)} */}
                    {order && <>
                        <img src={ body }
                                                // onLoad={imageLoaded} 
                            style={!load && !Object.keys(order).includes("item_type") ? {}:{display:"none"}}
                            className= {"o-c-d-img"}/>
                        <img src={ def_shirt }
                                                // onLoad={imageLoaded} 
                            style={!load && !Object.keys(order).includes("item_type") ? {}:{display:"none"}}
                            className= {"o-c-d-img"}/>
                        {order && Object.keys(order).includes("item_type") && order.item_type === 1  ? 
                        
                            <img 
                                src={order.src}
                                onLoad={imageLoaded1}
                                className= "o-c-d-img"
                            />
    
                        : order && Object.keys(order).includes("item_type") && order.item_type === 0  ? 
                        <img 
                                src={order.src}
                                onLoad={imageLoaded1}
                                className= "o-c-d-img"
                                style={{objectFit:"contain"}}
                            />
                        : order && !Object.keys(order).includes("item_type") ?
                            <>
                                {order && order.types && order.types.map((val, key)=>{
                                        return(
                                            <img src={ order && order.fabric && Object.hasOwn(order.fabric, val) ? order.fabric[val]["src"] : "" }
                                                onLoad={imageLoaded1}
                                                
                                                style={ !load ? {"zIndex":50-order.fabric[val]["pos"]} : {"display":"none"} } 
                                                className= {order.types.includes("Pant") ? "o-c-d-img":"o-c-d-img"}/>
                                        )
                                })}
                            </>
                            : <></>
                        }
                        
                        {/* <img src={order["fabric"]["Coat"]["src"]} className='o-c-d-img'/>
                        <img src={order["fabric"]["Pant"]["src"]} className='o-c-d-img'/> */}
                    </>}
                </div>
                <div className="o-c-d-des FIT_W">
                    <div className='verti_center' style={{"height":"fitContent"}}>
                    <label className='txt-font1'>{order.name}</label><br/>
                    {/* A boutique's piece: who it is for and which business ordered it. */}
                    {order.business && (
                        <div style={{ display: "flex", flexWrap: "wrap", gap: 6, margin: "4px 0" }}>
                            <span style={{ background: "#3e4a2f", color: "#f6f0e6", padding: "2px 8px", fontSize: "0.68rem", fontWeight: 800, letterSpacing: "0.08em" }}>
                                BUSINESS{order.offerCheck?.business?.name ? ` · ${order.offerCheck.business.name}` : ""}
                            </span>
                            {order.clientName && <span style={{ background: "#000", color: "#ddb56c", padding: "2px 8px", fontSize: "0.68rem", fontWeight: 800 }}>For {order.clientName}</span>}
                        </div>
                    )}
                    
                                <div className='less-mob'>
                                    Order Includes : {!Object.keys(order).includes("item_type") && order.types.map((val)=>{
                                        return(<span> {val}, </span>)
                                    })}
                                    { Object.keys(order).includes("item_type") && order.item_type === 1 ? 
                                        <></> 
                                        
                                        :Object.keys(order).includes("item_type") && order.item_type === 0 ?  <>Fabric only</> : <></>
    
                                    } 
                                    
                                    <br/> Click View Details to see Order info
                                    
                                    
                                    <div className="order-card-meta-line FIT_W">
                                        <span className="order-card-meta-date">
                                            {!Object.hasOwn(order, "status")
                                                ? `${date[2]}, ${months[date[1]]} ${date[0]}`
                                                : statusDate
                                                  ? `${statusDate[2]}, ${months[statusDate[1]]} ${statusDate[0]}`
                                                  : `${date[2]}, ${months[date[1]]} ${date[0]}`}
                                        </span>
                                        <span className="order-card-meta-sep">·</span>
                                        <b className="order-card-meta-status">
                                            {Object.hasOwn(order, "status") && order.status != null && order.status.status != null
                                                ? orderStatus[Number(order.status.status)] ?? orderStatus[0]
                                                : orderStatus[0]}
                                        </b>
                                    </div>
                                    
                                </div>
                            
                    </div>
                </div>
                
                <div className='o-c-d-b'>
            <button
                type="button"
                className="btn order-card-butt order-card-butt--primary"
                data-toggle="modal"
                data-target="#exampleModalCenter"
                onClick={() => {
                    setUpdate(order);
                }}
            >
                Update order
            </button>
            {/* The website's own order page, signed in as this admin (see
                Funtions/openOrderOnWebsite.js); the old in-panel modal stays
                as a quick view. */}
            <button
                type="button"
                className="order-card-butt order-card-butt--outline"
                onClick={() => {
                    if (!openOrderOnWebsite(order.id)) alert("Allow pop-ups for this site to open the order page.");
                }}
            >
                View order details
            </button>
            <button
                type="button"
                className="order-card-link"
                style={{ fontSize: "0.76rem", textAlign: "center", background: "none", border: 0, textDecoration: "underline", cursor: "pointer" }}
                onClick={() => {
                    setUpdate(order);
                    if (setOrderModal) setOrderModal(1);
                }}
            >
                Quick view
            </button>
            </div>
            </div>
            
            
        </div> 
        );
    }
    
    export default Order_card;